import { useMutation } from '@tanstack/react-query';
import { toast } from '@huspy/forge/shared';
import { vaultApi } from '@modules/vault/api';

const useCreateVault = (opportunityId: string) => {
  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['createVault', opportunityId],
    mutationFn: () =>
      vaultApi.createVault(opportunityId),
    onError: (err) => {
      toast('error', { message: err.message });
    },
  });

  return {
    mutate: mutateAsync,
    isPending,
  };
};

export default useCreateVault;
